import * as autoEllipsis from './auto-ellipsis';
import * as autoHide from './auto-hide';
import * as autoRotate from './auto-rotate';
export { autoHide, autoRotate, autoEllipsis };
//# sourceMappingURL=index.js.map